/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { InternalCommonCommentBaseToJSON, InternalCommonUserFromJSON, InternalUserCommentResponseV3FromJSON, InternalUserCommentsList200ResponseFromJSON, } from '../models/index';
/**
 *
 */
export class UserApi extends runtime.BaseAPI {
    /**
     * Creates a new comment resource. The comment will be associated with the current user.
     * Create a new comment
     */
    internalUserCommentsCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['internalCommonCommentBase'] == null) {
                throw new runtime.RequiredError('internalCommonCommentBase', 'Required parameter "internalCommonCommentBase" was null or undefined when calling internalUserCommentsCreate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            let urlPath = `/internal/user/v3/comments`;
            const response = yield this.request({
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: InternalCommonCommentBaseToJSON(requestParameters['internalCommonCommentBase']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InternalUserCommentResponseV3FromJSON(jsonValue));
        });
    }
    /**
     * Creates a new comment resource. The comment will be associated with the current user.
     * Create a new comment
     */
    internalUserCommentsCreate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.internalUserCommentsCreateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Deletes a comment owned by the current user. This operation cannot be undone.
     * Delete a comment
     */
    internalUserCommentsDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling internalUserCommentsDelete().');
            }
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/internal/user/v3/comments/{id}`;
            urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
            const response = yield this.request({
                path: urlPath,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes a comment owned by the current user. This operation cannot be undone.
     * Delete a comment
     */
    internalUserCommentsDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.internalUserCommentsDeleteRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Returns a paginated list of comments resources. Supports ordering by votes and includes pagination metadata.
     * Get comments resources
     */
    internalUserCommentsListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['parentType'] == null) {
                throw new runtime.RequiredError('parentType', 'Required parameter "parentType" was null or undefined when calling internalUserCommentsList().');
            }
            if (requestParameters['parentId'] == null) {
                throw new runtime.RequiredError('parentId', 'Required parameter "parentId" was null or undefined when calling internalUserCommentsList().');
            }
            const queryParameters = {};
            if (requestParameters['parentType'] != null) {
                queryParameters['parent_type'] = requestParameters['parentType'];
            }
            if (requestParameters['parentId'] != null) {
                queryParameters['parent_id'] = requestParameters['parentId'];
            }
            if (requestParameters['orderByVotes'] != null) {
                queryParameters['order_by_votes'] = requestParameters['orderByVotes'];
            }
            if (requestParameters['cursor'] != null) {
                queryParameters['cursor'] = requestParameters['cursor'];
            }
            if (requestParameters['pageSize'] != null) {
                queryParameters['page_size'] = requestParameters['pageSize'];
            }
            if (requestParameters['repliesLimit'] != null) {
                queryParameters['replies_limit'] = requestParameters['repliesLimit'];
            }
            const headerParameters = {};
            let urlPath = `/internal/user/v3/comments`;
            const response = yield this.request({
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InternalUserCommentsList200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * Returns a paginated list of comments resources. Supports ordering by votes and includes pagination metadata.
     * Get comments resources
     */
    internalUserCommentsList(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.internalUserCommentsListRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Updates a comment owned by the current user. Allows updating content, storage uploads, and attachments. Can also remove specific attachments.
     * Update a comment
     */
    internalUserCommentsUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling internalUserCommentsUpdate().');
            }
            if (requestParameters['internalCommonCommentBase'] == null) {
                throw new runtime.RequiredError('internalCommonCommentBase', 'Required parameter "internalCommonCommentBase" was null or undefined when calling internalUserCommentsUpdate().');
            }
            const queryParameters = {};
            if (requestParameters['uploadsIdsToDelete'] != null) {
                queryParameters['uploads_ids_to_delete'] = requestParameters['uploadsIdsToDelete'];
            }
            if (requestParameters['attachmentsIdsToDelete'] != null) {
                queryParameters['attachments_ids_to_delete'] = requestParameters['attachmentsIdsToDelete'];
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            let urlPath = `/internal/user/v3/comments/{id}`;
            urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
            const response = yield this.request({
                path: urlPath,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: InternalCommonCommentBaseToJSON(requestParameters['internalCommonCommentBase']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InternalUserCommentResponseV3FromJSON(jsonValue));
        });
    }
    /**
     * Updates a comment owned by the current user. Allows updating content, storage uploads, and attachments. Can also remove specific attachments.
     * Update a comment
     */
    internalUserCommentsUpdate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.internalUserCommentsUpdateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns the current user\'s information. Current user is the owner of the access_token used in the request.
     * Get current user information
     */
    internalUserMeRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/internal/user/v3/me`;
            const response = yield this.request({
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InternalCommonUserFromJSON(jsonValue));
        });
    }
    /**
     * Returns the current user\'s information. Current user is the owner of the access_token used in the request.
     * Get current user information
     */
    internalUserMe(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.internalUserMeRaw(initOverrides);
            return yield response.value();
        });
    }
}
